export const INVOICE_THEME = {
  gradient: 'linear-gradient(135deg, #3B82F6 0%, #8B5CF6 48%, #EC4899 100%)',
  gradientSoft: 'linear-gradient(135deg, rgba(59,130,246,0.08) 0%, rgba(139,92,246,0.08) 48%, rgba(236,72,153,0.08) 100%)',
  gradientHover: 'linear-gradient(135deg, #2563eb 0%, #7c3aed 48%, #db2777 100%)',
  gold: '#E8A838',
  goldDark: '#C8891E',
  ink: '#0f172a',
  slate: '#64748b',
  border: 'rgba(15, 23, 42, 0.08)',
  surface: '#ffffff',
  canvas: '#eef2f7',
  shadow: '0 24px 60px rgba(15, 23, 42, 0.12)',
  shadowSoft: '0 8px 30px rgba(59, 130, 246, 0.08)',
  radius: 16,
  radiusLg: 24,
};

export const fieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    bgcolor: '#f8fafc',
    transition: 'all 0.2s ease',
    '& fieldset': { borderColor: 'rgba(15, 23, 42, 0.1)' },
    '&:hover fieldset': { borderColor: 'rgba(59, 130, 246, 0.45)' },
    '&.Mui-focused': {
      bgcolor: '#fff',
      boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.12)',
    },
    '&.Mui-focused fieldset': { borderColor: '#3B82F6' },
  },
  '& .MuiInputLabel-root.Mui-focused': { color: '#3B82F6' },
};

export const primaryButtonSx = {
  background: INVOICE_THEME.gradient,
  color: '#fff',
  borderRadius: '12px',
  px: 2.5,
  py: 1,
  textTransform: 'none',
  fontWeight: 600,
  boxShadow: '0 8px 24px rgba(59, 130, 246, 0.35)',
  '&:hover': {
    background: INVOICE_THEME.gradientHover,
    boxShadow: '0 12px 28px rgba(236, 72, 153, 0.35)',
  },
  '&.Mui-disabled': {
    background: 'rgba(148, 163, 184, 0.35)',
    color: '#fff',
  },
};

export const ghostButtonSx = {
  borderRadius: '12px',
  px: 2,
  py: 0.85,
  textTransform: 'none',
  fontWeight: 600,
  color: '#475569',
  borderColor: 'rgba(15, 23, 42, 0.12)',
  bgcolor: '#fff',
  '&:hover': {
    bgcolor: '#f8fafc',
    borderColor: 'rgba(59, 130, 246, 0.35)',
  },
};
